import { FC, useEffect, RefObject, KeyboardEvent } from 'react'
import { findDOMNode } from 'react-dom'
import { AddressPlanType } from './types'
import { savePlaceAnswers } from './utils'
import Log from '@lib/Log'

const TOKEN = process.env.GOOGLE_MAPS_API_KEY
const SCRIPT_ID = 'google-maps-address-autocomplete'

const streetOptions = {
  types: ['geocode'],
  componentRestrictions: { country: 'us' }
}

type Props = {
  inputRef: RefObject<HTMLInputElement>
  onAnswerQuestion: (name: string, value: string) => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
}

export const AddressAutocomplete: FC<Props> = ({
  inputRef,
  onAnswerQuestion,
  onKeyDown,
}) => {
  let autocomplete: any

  useEffect(() => {
    initGoogleMapsApi()
    return detachGoogleMapsApi
  }, [])

  const initGoogleMapsApi = () => {
    if (document.getElementById(SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://maps.googleapis.com/maps/api/js?key=${TOKEN}&libraries=places`
    script.onload = handleAPILoad
    document.body.appendChild(script)
  }

  const detachGoogleMapsApi = () => {
    const script = document.getElementById(SCRIPT_ID)
    script && script.remove()
  }

  const handleAPILoad = () => {
    try {
      // @ts-ignore global google.
      if (!window.google) {
        Log.error(null, '[AddressAutocomplete] WARNING: google maps lib not available.')
        return
      }

      const input = findDOMNode(inputRef.current)
      // @ts-ignore global google.
      autocomplete = new google.maps.places.Autocomplete(input, streetOptions)
      autocomplete.addListener('place_changed', handlePlaceChange)
      onKeyDown && autocomplete.addListener('keydown', onKeyDown)
    } catch (error) {
      Log.error(null, '[AddressAutocomplete] WARNING: google maps lib not initialized.')
    }
  }

  const handlePlaceChange = () => {
    const place = autocomplete.getPlace() as AddressPlanType

    savePlaceAnswers({
      place,
      onAnswerQuestion,
    })
  }

  return null
}
